/**
 * Forthbridge Clinical Document
 * Forthbridge Clinical Document API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateDocumentStatusRequestDto { 
    /**
     * New status for the document
     */
    newStatus: UpdateDocumentStatusRequestDto.NewStatusEnum;
    /**
     * Reason for status change
     */
    statusReason?: string;
    /**
     * User making the status change
     */
    modifiedBy?: string;
}
export namespace UpdateDocumentStatusRequestDto {
    export type NewStatusEnum = 'open' | 'closed' | 'on_hold';
    export const NewStatusEnum = {
        Open: 'open' as NewStatusEnum,
        Closed: 'closed' as NewStatusEnum,
        OnHold: 'on_hold' as NewStatusEnum
    };
}


